/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "9efb3da2133eec01868077cedd1b6b6b7672e8b8";
